import {
  Children,
  Fragment,
  createContext,
  useContext,
  useId,
  useMemo,
} from 'react'

import { useDisclosure } from '../../hooks'
import type { ExpandableTextContextState, ExpandableTextProps } from './types'

const ExpandableTextContext = createContext<ExpandableTextContextState>(
  {} as ExpandableTextContextState,
)

export const useExpandableTextContext = () => useContext(ExpandableTextContext)

export const ExpandableText = ({
  children,
  defaultExpanded = false,
  id,
}: ExpandableTextProps) => {
  const { isOpen, onToggle } = useDisclosure({
    defaultOpen: defaultExpanded,
  })
  const textId = id ?? useId()

  const context = useMemo(
    () => ({
      isExpanded: isOpen,
      textId,
      onToggle,
    }),
    [isOpen, onToggle, textId],
  )

  return (
    <ExpandableTextContext.Provider value={context}>
      {children}
    </ExpandableTextContext.Provider>
  )
}
